if (!customElements.get('journal-article')) {
  customElements.define('journal-article', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-journal-content]');
      this.progress = this.querySelector('[data-journal-progress]');
      if (!this.content || !this.progress) return;

      this.updateProgress = this.updateProgress.bind(this);
      window.addEventListener('scroll', this.updateProgress, { passive: true });
      window.addEventListener('resize', this.updateProgress, { passive: true });
      this.updateProgress();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateProgress);
      window.removeEventListener('resize', this.updateProgress);
    }

    updateProgress() {
      const rect = this.content.getBoundingClientRect();
      const start = window.scrollY + rect.top - window.innerHeight * .35;
      const distance = Math.max(this.content.offsetHeight - window.innerHeight * .3, 1);
      const current = Math.min(Math.max((window.scrollY - start) / distance, 0), 1);
      this.style.setProperty('--journal-reading-progress', current.toFixed(4));
    }
  });
}
